(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORE_KEY = 'allin_wa_checkout_datos';
  var cartCache = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function money(cents) {
    var format = window.waCheckoutMoneyFormat || 'S/. {{amount}}';
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join('.'));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function modal() { return $('[data-wa-co]'); }

  /* ---------------- abrir / cerrar ---------------- */
  function open() {
    var m = modal();
    if (!m) return;
    // cerrar otros cajones (carrito lateral, menú)
    document.querySelectorAll('[data-drawer][data-open="true"]').forEach(function (d) {
      d.removeAttribute('data-open'); d.setAttribute('aria-hidden', 'true');
    });
    m.setAttribute('data-open', 'true');
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    restoreData();
    loadCart();
    setTimeout(function () { var f = $('#WaCoName'); if (f && !f.value) f.focus(); }, 320);
  }

  function close() {
    var m = modal();
    if (!m) return;
    m.removeAttribute('data-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  /* ---------------- carrito ---------------- */
  function loadCart() {
    var list = $('[data-wa-co-items]');
    var total = $('[data-wa-co-total]');
    var submit = $('[data-wa-co-submit]');
    list.innerHTML = '<p class="wa-co__loading">Cargando tu pedido…</p>';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCache = cart;
        if (!cart.items.length) {
          list.innerHTML = '<p class="wa-co__empty">Tu carrito está vacío.</p>';
          total.textContent = money(0);
          submit.disabled = true;
          return;
        }
        submit.disabled = false;
        list.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="wa-co__item-variant">' + esc(it.variant_title) + '</span>' : '';
          return '<div class="wa-co__item">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '<span class="wa-co__item-ph"></span>') +
            '<div><span class="wa-co__item-title">' + esc(it.product_title) + '</span>' + variant +
            '<span class="wa-co__item-qty">' + it.quantity + ' × ' + money(it.final_price) + '</span></div>' +
            '<span class="wa-co__item-price">' + money(it.final_line_price) + '</span></div>';
        }).join('');
        total.textContent = money(cart.total_price);
      })
      .catch(function () {
        list.innerHTML = '<p class="wa-co__empty">No pudimos cargar tu carrito. Recarga la página e inténtalo de nuevo.</p>';
      });
  }

  /* ---------------- datos guardados (solo en este navegador) ---------------- */
  var FIELDS = ['name', 'phone', 'city', 'district', 'address', 'reference'];

  function saveData(data) {
    try {
      var keep = {};
      FIELDS.forEach(function (k) { keep[k] = data[k] || ''; });
      localStorage.setItem(STORE_KEY, JSON.stringify(keep));
    } catch (e) {}
  }

  function restoreData() {
    var form = $('[data-wa-co-form]');
    if (!form) return;
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
      FIELDS.forEach(function (k) {
        if (saved[k] && form.elements[k] && !form.elements[k].value) form.elements[k].value = saved[k];
      });
    } catch (e) {}
  }

  /* ---------------- validación y envío ---------------- */
  function showError(msg, field) {
    var box = $('[data-wa-co-error]');
    box.textContent = msg;
    box.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
  }

  function clearErrors(form) {
    $('[data-wa-co-error]').hidden = true;
    Array.prototype.forEach.call(form.elements, function (el) { el.removeAttribute && el.removeAttribute('aria-invalid'); });
  }

  function buildMessage(d, cart) {
    var shop = modal().getAttribute('data-shop-name') || 'la tienda';
    var lines = [];
    lines.push('Hola 👋, quiero confirmar mi pedido en *' + shop + '*');
    lines.push('');
    lines.push('🛒 *Pedido:*');
    cart.items.forEach(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : '';
      lines.push('• ' + it.quantity + ' × ' + it.product_title + v + ' — ' + money(it.final_line_price));
    });
    lines.push('');
    lines.push('💰 *Total:* ' + money(cart.total_price) + ' + envío a coordinar');
    lines.push('');
    lines.push('📦 *Datos de entrega:*');
    lines.push('Nombre: ' + d.name);
    lines.push('WhatsApp: +51 ' + d.phone);
    lines.push('Ciudad: ' + d.city);
    lines.push('Distrito: ' + d.district);
    lines.push('Dirección: ' + d.address);
    if (d.reference) lines.push('Referencia: ' + d.reference);
    if (d.note) { lines.push(''); lines.push('📝 *Nota:* ' + d.note); }
    return lines.join('\n');
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.target;
    clearErrors(form);

    var d = {};
    ['name', 'phone', 'city', 'district', 'address', 'reference', 'note'].forEach(function (k) {
      d[k] = (form.elements[k].value || '').trim();
    });
    d.phone = d.phone.replace(/\D/g, '').replace(/^51(?=\d{9}$)/, '');

    if (!cartCache || !cartCache.items.length) return showError('Tu carrito está vacío.');
    if (d.name.length < 3) return showError('Escribe tu nombre completo.', form.elements.name);
    if (!/^9\d{8}$/.test(d.phone)) return showError('Escribe un celular válido de 9 dígitos (empieza con 9).', form.elements.phone);
    if (!d.city) return showError('Escribe tu ciudad o provincia.', form.elements.city);
    if (!d.district) return showError('Escribe tu distrito.', form.elements.district);
    if (d.address.length < 5) return showError('Escribe tu dirección completa.', form.elements.address);

    saveData(d);

    var number = modal().getAttribute('data-wa-number');
    var url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(buildMessage(d, cartCache));

    // Guarda los datos en el carrito (quedan como referencia si luego se crea el pedido en Shopify)
    try {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          note: d.note,
          attributes: { 'Nombre': d.name, 'WhatsApp': '+51 ' + d.phone, 'Ciudad': d.city, 'Distrito': d.district, 'Dirección': d.address, 'Referencia': d.reference, 'Canal': 'WhatsApp' }
        }),
        keepalive: true
      });
    } catch (err) {}

    window.location.href = url;
  }

  /* ---------------- "Comprar ahora" desde la página de producto ---------------- */
  function buyNow(btn) {
    var form = btn.closest('form') || document.getElementById('product-form');
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    if (!idInput) { open(); return; }
    var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar'); return data; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.classList.contains('site-header__cart-count')) el.hidden = cart.item_count === 0;
        });
        open();
      })
      .catch(function (err) { alert(err.message); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ---------------- eventos ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-wa-checkout]');
    if (trigger) { e.preventDefault(); open(); return; }
    var buy = e.target.closest('[data-wa-buy]');
    if (buy) { e.preventDefault(); buyNow(buy); return; }
    if (e.target.closest('[data-wa-co-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-wa-co-form]')) onSubmit(e);
  });
  document.addEventListener('input', function (e) {
    if (e.target.name === 'phone' && e.target.closest('[data-wa-co-form]')) {
      e.target.value = e.target.value.replace(/[^\d ]/g, '');
    }
  });

  // Abrir directo con ?pedido=whatsapp (útil para links desde TikTok/Instagram)
  document.addEventListener('DOMContentLoaded', function () {
    if (/[?&]pedido=whatsapp\b/.test(window.location.search)) open();
  });
})();
